import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path fillRule="evenodd" d="M3 9.5L4.5 8l7.5 7.554L19.5 8 21 9.5l-9 9z" />
  </React.Fragment>,
  `ArrowDownIcon`
);
